"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Svg = _interopRequireDefault(require("../../../../Svg/Svg"));
var _Avatar = _interopRequireDefault(require("../../../../Avatar/Avatar"));
var _constants = require("../../../../constants");
var _formatting = require("../../../../../helpers/formatting");
var Quote = function Quote(_ref) {
  var quote = _ref.quote,
    author = _ref.author,
    whiteFont = _ref.whiteFont;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-relative image--quote flex flex-column justify-center height-100% "
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-width-xs"
  }, /*#__PURE__*/_react["default"].createElement("blockquote", {
    className: (0, _classnames["default"])(whiteFont && 'd8-u-color-white', 'd8-u-ls-sm', 'text-component')
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "quote",
    fill: _constants.COLORS.WHITE,
    className: "icon--xl"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm"
  }, quote), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, author && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatarType: _constants.AVATAR_TYPES.CIRCLE,
    avatarSize: _constants.AVATAR_SIZES.MEDIUM,
    avatarColor: _constants.AVATAR_COLORS.PRIMARY,
    image: author.image && {
      url: author.image,
      alt: author.name
    },
    initials: (0, _formatting.getInitialsFromName)(author.name && author.name.split(' ')[0], author.name && author.name.split(' ')[1])
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])(whiteFont && 'd8-u-color-white', 'text-xs', 'text-left', 'author', 'margin-left-sm', 'margin-top-xxxs')
  }, author.name))))));
};
Quote.propTypes = {
  quote: _propTypes["default"].string,
  author: _propTypes["default"].object,
  whiteFont: _propTypes["default"].bool
};
var _default = exports["default"] = Quote;